import { createSelector } from 'reselect';
import sysUtils from 'utils/ShopYourStore';

import { showShopYourStorePreselectFulfillmentAbTestSelector } from 'viewModel/selectors/testTarget/showShopYourStorePreselectFulfillmentAbTestSelector';

const isShopYourStorePreselectFulfillmentEnabledSelector = createSelector(
    showShopYourStorePreselectFulfillmentAbTestSelector,
    showShopYourStorePreselectFulfillmentAbTest => {
        const globalKillswitch = sysUtils.shopYourStoreV2Enabled();
        const isShopYourStorePreselectFulfillmentEnabled = globalKillswitch && showShopYourStorePreselectFulfillmentAbTest;

        return isShopYourStorePreselectFulfillmentEnabled;
    }
);

export { isShopYourStorePreselectFulfillmentEnabledSelector };
